// extracted by mini-css-extract-plugin
export var form = "_4w-0";